import React from 'react';
import { FloatingTooltip } from 'components/floating-tooltip/floating-tooltip';
import styles from './calculation-icon-trigger.module.scss';

interface CalculationIconTriggerProps {
  active?: boolean;
  definition: string;
  children: React.ReactNode;
  onClick?: () => void;
}

export const CalculationIconTrigger: React.FC<CalculationIconTriggerProps> = ({
  active = false,
  definition,
  children,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.stopPropagation();
      onClick();
    }
  };

  if (active) {
    return (
      <div
        className={`${styles.iconButtonWrapper} ${styles.calculationIconActive}`}
        onClick={handleClick}
      >
        {children}
      </div>
    );
  }

  return (
    <FloatingTooltip content={definition} placement="top">
      <div
        className={`${styles.iconButtonWrapper} ${styles.calculationIconWrapper}`}
        onClick={handleClick}
      >
        {children}
      </div>
    </FloatingTooltip>
  );
};
